<div class="flex justify-between pt-5 pb-5 items-center">
    <span>{{ countLabel }}: {{ countValue }}</span>
    <div>
        <ng-container *ngFor="let button of buttons">
            <button (click)="emitClickButton(button.key)"
                    class="secondary-button ml-3"
                    *permissionsRequired="button.permissions || []">
                {{ button.label }}
            </button>
        </ng-container>    
    </div>
</div>